import { useState } from "react";
import { Anchor, Text } from "@mantine/core";

const COLLAPSE_THRESHOLD = 250;
const COLLAPSED_LENGTH = 170;

/** Read-only description with a "more / less" toggle for long text. */
export default function RuleDescription({ description }) {
  const [expanded, setExpanded] = useState(false);

  if (!description) return null;

  if (description.length < COLLAPSE_THRESHOLD) {
    return <Text size="sm">{description}</Text>;
  }

  return (
    <Text size="sm">
      {expanded ? description : description.substring(0, COLLAPSED_LENGTH)}
      {expanded ? (
        <Anchor component="button" size="sm" onClick={() => setExpanded(false)} ml={4}>
          less
        </Anchor>
      ) : (
        <>
          {" ... "}
          <Anchor component="button" size="sm" onClick={() => setExpanded(true)}>
            more
          </Anchor>
        </>
      )}
    </Text>
  );
}
